module.exports = __webpack_public_path__ + "img/bg_kv_2_pink.5870bec9.svg";